import axios, { AxiosResponse } from "axios";
import { useContext } from "react";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import titleData from "../../common/utils/pageTitle.json";
import { UserContext } from "../../component/layout/layout";
import { authorizationConstant, CommonConstants } from "./CommonConstants";
import { uuidRegex } from "./constant";
const MySwal = withReactContent(Swal);
const Toast = MySwal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 5000,
  background: "#a5dc86",
  iconColor: "#303030",
  color: "#303030",
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener("mouseenter", Swal.stopTimer);
    toast.addEventListener("mouseleave", Swal.resumeTimer);
  },
});

const baseUrl = process.env.REACT_APP_BASE_URL;
export const homeUrl = process.env.REACT_APP_HOME_URL;
export const failUrl = process.env.REACT_APP_Fail_URL;
// let token = localStorage.getItem("accessToken");

// export let config = {
//   headers: {
//     Authorization: `Bearer ${token}`,
//   },
// };

axios.interceptors.response.use(
  function (response: any) {
    let newAccessToken =
      response?.headers?.get("x-new-token") ||
      response?.headers?.get["X-New-Token"];
    if (newAccessToken) {
      localStorage.setItem("accessToken", newAccessToken);
    }
    return response;
  },
  function (error) {
    return Promise.reject(error);
  }
);

export function getToken(reqUrl: string) {
  let token;
  if (reqUrl.includes("External")) {
    token = new URLSearchParams(location.search)
      .get("token")
      ?.replace(/ /g, "+");
  } else {
    token = localStorage.getItem("accessToken");
  }
  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
}

const axiosPost = (reqUrl: string, reqBody: any, RoleService?: boolean) => {
  let baseUrl = process.env.REACT_APP_BASE_URL;
  const config = getToken(reqUrl);
  if (RoleService) {
    baseUrl = process.env.REACT_APP_BASE_URL_ROLE;
  }
  if (reqBody != undefined && reqBody != null) {
    try {
      reqBody = btoa(encodeURIComponent(JSON.stringify(reqBody)));
    } catch (error) {
      alert("error in encryption");
      console.log("error in encryption", error);
    }
  }

  return new Promise((resolve, reject) => {
    axios
      .post(baseUrl + reqUrl, { reqBody }, config)
      .then(function (response: any) {
        if (
          response.status == CommonConstants.API_RESPONSE_SUCCESSFULL ||
          CommonConstants.API_RESPONSE_ACCEPTED
        ) {
          resolve(response);
        } else {
          reject(response);
        }
      })
      .catch(function (error: any) {
        if (error.response) {
          if (
            error.response.status ==
            CommonConstants.API_RESPONSE_UNAUTHORIZED_ACCESS
          ) {
            localStorage.removeItem("accessToken");
            if (reqUrl.includes("External")) {
              window.location.href = `${failUrl}?message=This link is invalid or has been tampered with.`;
            } else {
              window.location.href = `${homeUrl}`;
            }
          }
          if (
            [
              CommonConstants.API_RESPONSE_CONFLICTS_IN_REQUEST,
              CommonConstants.API_RESPONSE_BAD_REQUEST,
            ].includes(error.response.status)
          ) {
            resolve(error.response);
          } else {
            console.log("error", error.response.data.error);
          }
        } else if (error.request) {
          console.log(
            "error on the server and the request could not be completed.",
            error.request
          );
        }
        reject(error);
      });
  });
};

const CommonGatewayAxiosPost = (reqUrl: string, reqBody: any) => {
  const commonGatewayUrl: string | undefined =
    process.env.REACT_APP_BASE_URL_GATEWAY;
  const config = getToken(reqUrl);
  return new Promise((resolve, reject) => {
    axios
      .post(commonGatewayUrl + reqUrl, reqBody, config)
      .then(function (response: any) {
        if (
          [
            CommonConstants.API_RESPONSE_SUCCESSFULL,
            CommonConstants.API_RESPONSE_ACCEPTED,
            CommonConstants.API_RESPONSE_CONFLICTS_IN_REQUEST,
          ].includes(response.status)
        ) {
          resolve(response);
        } else {
          reject(response);
        }
      })
      .catch(function (error: any) {
        if (error.response) {
          if (
            error.response.status ===
            CommonConstants.API_RESPONSE_UNAUTHORIZED_ACCESS
          ) {
            localStorage.removeItem("accessToken");
            window.location.href = `${homeUrl}`;
          }
          if (
            error.response.status ===
            CommonConstants.API_RESPONSE_CONFLICTS_IN_REQUEST
          ) {
            resolve(error.response);
          } else {
            resolve(error);
          }
        } else if (error.request) {
          console.log(
            "error on the server and the request could not be completed.",
            error.request
          );
        }
        reject(error);
      });
  });
};

const axiosUpdate = (reqUrl: string, reqBody: any, RoleService?: boolean) => {
  let baseUrl = process.env.REACT_APP_BASE_URL;
  const config = getToken(reqUrl);
  if (reqBody != undefined && reqBody != null) {
    try {
      reqBody = btoa(encodeURIComponent(JSON.stringify(reqBody)));
    } catch (error) {
      console.log("error in encryption", error);
    }
  }
  if (RoleService) {
    baseUrl = process.env.REACT_APP_BASE_URL_ROLE;
  }
  return new Promise((resolve, reject) => {
    axios
      .put(baseUrl + reqUrl, { reqBody }, config)
      .then(function (response: any) {
        if (
          response.status === CommonConstants.API_RESPONSE_SUCCESSFULL ||
          CommonConstants.API_RESPONSE_ACCEPTED
        ) {
          resolve(response);
        } else {
          reject(response);
        }
      })
      .catch(function (error: any) {
        if (error.response) {
          if (
            error.response.status ==
            CommonConstants.API_RESPONSE_UNAUTHORIZED_ACCESS
          ) {
            localStorage.removeItem("accessToken");
            window.location.href = `${homeUrl}`;
          }
          if (
            error.response.status ===
            CommonConstants.API_RESPONSE_CONFLICTS_IN_REQUEST
          ) {
            resolve(error.response);
          } else {
            console.log("error", error.response.data.error);
          }
        } else if (error.request) {
          console.log(
            "error on the server and the request could not be completed.",
            error.request
          );
        }
        reject(error);
      });
  });
};

const axiosPatch = (reqUrl: string, reqBody: any) => {
  const config = getToken(reqUrl);
  if (reqBody != undefined && reqBody != null) {
    try {
      reqBody = btoa(encodeURIComponent(JSON.stringify(reqBody)));
    } catch (error) {
      console.log("error in encryption", error);
    }
  }

  return new Promise((resolve, reject) => {
    axios
      .patch(baseUrl + reqUrl, { reqBody }, config)
      .then(function (response: any) {
        if (
          response.status == CommonConstants.API_RESPONSE_SUCCESSFULL ||
          CommonConstants.API_RESPONSE_ACCEPTED
        ) {
          resolve(response);
        } else {
          reject(response);
        }
      })
      .catch(function (error: any) {
        if (error.response) {
          if (
            error.response.status ==
            CommonConstants.API_RESPONSE_UNAUTHORIZED_ACCESS
          ) {
            localStorage.removeItem("accessToken");
            window.location.href = `${homeUrl}`;
          }
          if (
            error.response.status ===
            CommonConstants.API_RESPONSE_CONFLICTS_IN_REQUEST
          ) {
            resolve(error.response);
          } else {
            console.log("error", error.response.data.error);
          }
        } else if (error.request) {
          console.log(
            "error on the server and the request could not be completed.",
            error.request
          );
        }
        reject(error);
      });
  });
};
const axiosGet = (reqUrl: string, reqBody?: any, RoleService?: boolean) => {
  const config = getToken(reqUrl);
  let baseUrl = process.env.REACT_APP_BASE_URL;
  if (!reqBody) {
    reqBody = {};
  }
  if (RoleService) {
    baseUrl = process.env.REACT_APP_BASE_URL_ROLE;
  }
  if (
    reqBody != undefined &&
    reqBody != null &&
    JSON.stringify(reqBody) !== "{}"
  ) {
    try {
      reqBody = btoa(encodeURIComponent(JSON.stringify(reqBody)));
    } catch (error) {
      console.log("error in encryption", error);
    }
  }

  return new Promise((resolve, reject) => {
    axios
      .get(baseUrl + reqUrl, {
        params: JSON.stringify(reqBody) !== "{}" && { reqBody },
        ...config,
      })
      .then(function (response: any) {
        if (response.status == CommonConstants.API_RESPONSE_SUCCESSFULL) {
          resolve(response);
        } else {
          reject(response);
        }
      })
      .catch(function (error: any) {
        if (error.response) {
          if (
            error.response.status ==
            CommonConstants.API_RESPONSE_UNAUTHORIZED_ACCESS
          ) {
            localStorage.removeItem("accessToken");
            if (reqUrl.includes("External")) {
              window.location.href = `${failUrl}?message=${error.response.data.error}`;
            } else {
              window.location.href = `${homeUrl}`;
            }
          } else {
            console.log("error", error.response.data.error);
          }
        } else if (error.request) {
          console.log(
            "error on the server and the request could not be completed.",
            error.request
          );
        }
        reject(error);
      });
  });
};
const axiosDelete = (reqUrl: string, RoleService?: boolean) => {
  let baseUrl = process.env.REACT_APP_BASE_URL;
  if (RoleService) {
    baseUrl = process.env.REACT_APP_BASE_URL_ROLE;
  }
  const config = getToken(reqUrl);
  return new Promise((resolve, reject) => {
    axios
      .patch(baseUrl + reqUrl, {}, config)

      .then(function (response: any) {
        if (response.status === CommonConstants.API_RESPONSE_SUCCESSFULL) {
          resolve(response);
        } else {
          reject(response);
        }
      })
      .catch(function (error: any) {
        if (error.response) {
          if (
            error.response.status ==
            CommonConstants.API_RESPONSE_UNAUTHORIZED_ACCESS
          ) {
            localStorage.removeItem("accessToken");
            window.location.href = `${homeUrl}`;
          } else {
            console.log("error", error.response.data.error);
          }
        } else if (error.request) {
          console.log(
            "error on the server and the request could not be completed.",
            error.request
          );
        }
        reject(error);
      });
  });
};

const axiosRemove = (reqUrl: string, RoleService?: boolean) => {
  let baseUrl = process.env.REACT_APP_BASE_URL;
  if (RoleService) {
    baseUrl = process.env.REACT_APP_BASE_URL_ROLE;
  }
  const config = getToken(reqUrl);
  return new Promise((resolve, reject) => {
    axios
      .delete(baseUrl + reqUrl, config)
      .then(function (response: any) {
        if (response.status === CommonConstants.API_RESPONSE_SUCCESSFULL) {
          resolve(response);
        } else {
          reject(response);
        }
      })
      .catch(function (error: any) {
        if (error.response) {
          if (
            error.response.status ==
            CommonConstants.API_RESPONSE_UNAUTHORIZED_ACCESS
          ) {
            localStorage.removeItem("accessToken");
            window.location.href = `${homeUrl}`;
          } else {
            console.log("error", error.response.data.error);
          }
        } else if (error.request) {
          console.log(
            "error on the server and the request could not be completed.",
            error.request
          );
        }
        reject(error);
      });
  });
};

const axiosGetParams = (reqUrl: string, RoleService?: boolean) => {
  let baseUrl = process.env.REACT_APP_BASE_URL;
  const config = getToken(reqUrl);
  if (RoleService) {
    baseUrl = process.env.REACT_APP_BASE_URL_ROLE;
  }
  return new Promise((resolve, reject) => {
    axios
      .get(baseUrl + reqUrl, {
        headers: config.headers,
      })
      .then(function (response: AxiosResponse) {
        if (response.status == CommonConstants.API_RESPONSE_SUCCESSFULL) {
          resolve(response);
        } else {
          reject(response);
        }
      })
      .catch(function (error: any) {
        if (error.response) {
          if (
            error.response.status ==
            CommonConstants.API_RESPONSE_UNAUTHORIZED_ACCESS
          ) {
            localStorage.removeItem("accessToken");
            if (reqUrl.includes("External")) {
              window.location.href = `${failUrl}?message=${error.response.data.error}`;
            } else {
              window.location.href = `${homeUrl}`;
            }
          } else {
            console.log("error", error.response.data.error);
          }
        } else if (error.request) {
          console.log(
            "error on the server and the request could not be completed.",
            error.request
          );
        }
        reject(error);
      });
  });
};
const ChatbotAxiosPost = (reqUrl: string, reqBody: any) => {
  const commonGatewayUrl: string | undefined =
    process.env.REACT_APP_BASE_URL_GATEWAY;
  const config = {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("chatToken")}`,
      "x-tenant": localStorage.getItem("x-tenant"),
    },
  };

  return new Promise((resolve, reject) => {
    axios
      .post(commonGatewayUrl + reqUrl, reqBody, config)

      .then(function (response: any) {
        if (
          [
            CommonConstants.API_RESPONSE_SUCCESSFULL,
            CommonConstants.API_RESPONSE_ACCEPTED,
          ].includes(response.status)
        ) {
          resolve(response);
        } else {
          reject(response);
        }
      })
      .catch(function (error: any) {
        if (error.response) {
          if (
            error.response.status ==
            CommonConstants.API_RESPONSE_UNAUTHORIZED_ACCESS
          ) {
            localStorage.removeItem("accessToken");
            window.location.href = `${homeUrl}`;
          } else {
            resolve(error);
          }
        } else if (error.request) {
          console.log(
            "error on the server and the request could not be completed.",
            error.request
          );
        }
        reject(error);
      });
  });
};
//fetch page title based on route selected
const getPageTitle = (breadcrumb: any) => {
  let title: keyof typeof titleData = breadcrumb?.props?.children;
  return titleData[title];
};

// convert camel case into title
const camel2title = (breadcrumb: any) => {
  let title = breadcrumb?.props?.children;
  if (title === "JdTemplate") return "JD Template";
  else if (title === "AddJdTemplate") return "Add JD Template";
  else if (title === "EditJdTemplate") return "Edit JD Template";
  else if (title === "EditLetterConfiguration") return "Edit Letter Configuration";
  let result = title?.replace(/([A-Z])/g, " $1");
  return result && result.charAt(0).toUpperCase() + result.slice(1);
};

const checkNumber = (num: any) => {
  let a = num?.props?.children;
  if (!isNaN(Number(a))) return true;
  else if (uuidRegex.test(a)) return true;
  return false;
};

// check for duplicate values in numeraic array
function containsDuplicates(array: (number | null)[]) {
  if (array.length !== new Set(array).size) {
    return true;
  }
  return false;
}
// check all object key has a value
const validateFields = (obj: any, fieldsToExclude: string[]) => {
  for (const key in obj) {
    if (obj.hasOwnProperty(key) && !fieldsToExclude.includes(key)) {
      if (
        obj[key] === null ||
        obj[key] === undefined ||
        (typeof obj[key] === "string" && obj[key].trim().length === 0)
      ) {
        return false;
      }
    }
  }
  return true;
};
//display toast message dynamically - finalize candidate
const displaySuccessMessage = (status: string) => {
  switch (status) {
    case "Offered":
      return "The candidate has been offered successfully.";
    case "Accepted":
      return "The candidate has accepted the offer successfully";
    case "Declined":
      return "The candidate has declined the offer.";
    case "Drop Out":
      return "The candidate has been dropped out";
    case "On Hold":
      return "The candidate has been on hold.";
    case "Blacklist":
      return "The candidate has been blacklisted.";
    case "Joined":
      return "The candidate has been joined successfully.";
    default:
      return undefined;
  }
};
const axiosGetExternal = (reqUrl: string) => {
  return new Promise((resolve, reject) => {
    axios
      .get(reqUrl, {})
      .then(function (response: AxiosResponse) {
        if (response.status == CommonConstants.API_RESPONSE_SUCCESSFULL) {
          resolve(response);
        } else {
          reject(response);
        }
      })
      .catch(function (error: any) {
        if (error.response) {
          if (
            error.response.status ==
            CommonConstants.API_RESPONSE_UNAUTHORIZED_ACCESS
          ) {
            if (reqUrl.includes("External")) {
              window.location.href = `${failUrl}?message=${error.response.data.error}`;
            } else {
              window.location.href = `${homeUrl}`;
            }
          } else {
            console.log("error", error.response.data.error);
          }
        } else if (error.request) {
          console.log(
            "error on the server and the request could not be completed.",
            error.request
          );
        }
        reject(error);
      });
  });
};

const checkCurrentRoleIsSuperAdmin = (userRole: string) => {
  const role = userRole?.replace(/\s+/g, "").toLowerCase();
  const superAdmin = authorizationConstant.roleSuperAdmin
    .replace(/\s+/g, "")
    .toLowerCase();

  // Compare the cleaned strings
  return role === superAdmin;
};

const axiosPostExternal = (reqUrl: string, reqBody: any) => {
  const config = {};
  return new Promise((resolve, reject) => {
    axios
      .post(reqUrl, reqBody, config)
      .then(function (response: any) {
        if (
          response.status == CommonConstants.API_RESPONSE_SUCCESSFULL ||
          CommonConstants.API_RESPONSE_ACCEPTED
        ) {
          resolve(response);
        } else {
          reject(response);
        }
      })
      .catch(function (error: any) {
        if (error.response) {
          if (
            error.response.status ==
            CommonConstants.API_RESPONSE_UNAUTHORIZED_ACCESS
          ) {
            localStorage.removeItem("accessToken");
            if (reqUrl.includes("External")) {
              window.location.href = `${failUrl}?message=${error.response.data.error}`;
            } else {
              window.location.href = `${homeUrl}`;
            }
          }
          if (
            [
              CommonConstants.API_RESPONSE_CONFLICTS_IN_REQUEST,
              CommonConstants.API_RESPONSE_BAD_REQUEST,
            ].includes(error.response.status)
          ) {
            resolve(error.response);
          } else {
            console.log("error", error.response.data.error);
          }
        } else if (error.request) {
          console.log(
            "error on the server and the request could not be completed.",
            error.request
          );
        }
        reject(error);
      });
  });
};
const GetUserDateFormat = (formatType: any) => {
  const { user }: any = useContext(UserContext);
  if (formatType === "dateTime") {
    return user?.dateTimeFormat;
  }
  return user?.dateFormat;
};
const toCamelCase = (input: string): string => {
  return input
    .split(/[-_\s]+/) // Split by hyphens, underscores, or spaces
    .map((word, index) => {
      if (index === 0) {
        return word.toLowerCase(); // Lowercase the first word
      }
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase(); // Capitalize the first letter of subsequent words
    })
    .join("");
};

// Utility function to format duration
const formatDuration = (duration: number): string => {
  const minutes = Math.floor(duration / 60);
  const seconds = Math.floor(duration % 60);
  if (minutes > 0 && seconds > 0) {
    return `${minutes} minute${minutes > 1 ? "s" : ""} & ${seconds} second${
      seconds > 1 ? "s" : ""
    }`;
  } else if (minutes > 0) {
    return `${minutes} minute${minutes > 1 ? "s" : ""}`;
  } else {
    return `${seconds} second${seconds > 1 ? "s" : ""}`;
  }
};

const axiosPostMultipart = (reqUrl: string, formData: FormData) => {
  let baseUrl = process.env.REACT_APP_BASE_URL;
  const tokenConfig = getToken(reqUrl); // returns { headers: { Authorization: ... } }

  // Merge with timeout config
  const config = {
    ...tokenConfig,
    timeout: 300000, // 5 minutes in milliseconds
  };

  return new Promise((resolve, reject) => {
    axios
      .post(baseUrl + reqUrl, formData, config)
      .then((response) => {
        if (
          response.status === CommonConstants.API_RESPONSE_SUCCESSFULL ||
          response.status === CommonConstants.API_RESPONSE_ACCEPTED
        ) {
          resolve(response);
        } else {
          reject(response);
        }
      })
      .catch((error) => {
        if (error.response) {
          if (
            error.response.status ==
            CommonConstants.API_RESPONSE_UNAUTHORIZED_ACCESS
          ) {
            localStorage.removeItem("accessToken");
            if (reqUrl.includes("External")) {
              window.location.href = `${failUrl}?message=${error.response.data.error}`;
            } else {
              window.location.href = `${homeUrl}`;
            }
          }
          if (
            [
              CommonConstants.API_RESPONSE_CONFLICTS_IN_REQUEST,
              CommonConstants.API_RESPONSE_BAD_REQUEST,
            ].includes(error.response.status)
          ) {
            resolve(error.response);
          } else {
            console.log("error", error.response.data.error);
          }
        } else if (error.request) {
          console.log(
            "error on the server and the request could not be completed.",
            error.request
          );
        }
        reject(error);
      });
  });
};

const toTitleCase = (str: string) => {
  return str.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substring(1).toLowerCase());
}

// Generic deep comparison function
const isDeepEqual = (a: any, b: any): boolean => {
  if (a === b) return true; // Same reference or primitive

  if (typeof a !== "object" || typeof b !== "object" || a === null || b === null) {
    return false; // One is primitive, the other is object
  }

  if (Array.isArray(a) && Array.isArray(b)) {
    if (a.length !== b.length) return false;
    for (let i = 0; i < a.length; i++) {
      if (!isDeepEqual(a[i], b[i])) return false;
    }
    return true;
  }

  const keysA = Object.keys(a);
  const keysB = Object.keys(b);

  if (keysA.length !== keysB.length) return false;

  for (let key of keysA) {
    if (!keysB.includes(key) || !isDeepEqual(a[key], b[key])) return false;
  }

  return true;
};
const isValidDate = (d: any) => d instanceof Date && !isNaN(d.getTime());

export const serializeError = (error: any) => {
  if (!error) return null;

  return {
    name: error.name,
    message: error.message,
    stack: error.stack,

    isAxiosError: error.isAxiosError,

    config: error.config && {
      url: error.config.url,
      method: error.config.method,
      timeout: error.config.timeout,
      headers: error.config.headers,
      data: error.config.data,
    },

    response: error.response && {
      status: error.response.status,
      statusText: error.response.statusText,
      headers: error.response.headers,
      data: error.response.data,
    },

    request: error.request ? "Request object exists (network error)" : null,
  };
};


const getPlanLimit = (user: any, key: string) => {
  return user?.plan_attributes?.find((item: any) => item.attribute_key === key)
    ?.attribute_value ?? 0;
}

const htmlToText = (html: string) => {
  const div = document.createElement("div");
  div.innerHTML = html;
  return (div.textContent || div.innerText || "")
    .replace(/\u00A0/g, " ")          // &nbsp;
    .replace(/\r?\n+/g, "\n")         // collapse multiple newlines
    .replace(/[ \t]+/g, " ")          // collapse spaces
    .replace(/\n\s+/g, "\n")          // trim line starts
    .trim();
}


export {
  axiosDelete,
  axiosRemove,
  axiosGet,
  axiosGetExternal,
  axiosGetParams,
  axiosPatch,
  axiosPost,
  axiosPostExternal,
  axiosUpdate,
  camel2title,
  ChatbotAxiosPost,
  checkCurrentRoleIsSuperAdmin,
  checkNumber,
  CommonGatewayAxiosPost,
  containsDuplicates,
  displaySuccessMessage,
  formatDuration,
  getPageTitle,
  GetUserDateFormat,
  Toast,
  toCamelCase,
  validateFields,
  axiosPostMultipart,
  toTitleCase,
  isDeepEqual,
  isValidDate,
  getPlanLimit,
  htmlToText
};
